import { drugsConstants } from '../constants';
import {List} from "immutable";

export function drugs(state = {}, action) {
  switch (action.type) {
    case drugsConstants.GETDRUGS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        data: new List()
      });
    case drugsConstants.GETDRUGS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data.data
      });
    case drugsConstants.GETDRUGS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state
  }
}
